import React, { useState, useMemo } from "react"
import { Row, Col, Label, FormGroup, Card, CardBody, Button } from "reactstrap"
import { CSVLink } from "react-csv"
import ReactTable from "react-table"
import Select from "react-select"
import { getOptions, useQueryData } from "utils"
import { useQuery } from "@apollo/react-hooks"
import { orderStatusTypes, findTypeValueByKey } from "utils/types"
import { GET_COMPANIES, GET_ORDERS } from "../gql"

// main component
const OrderExportContainer = () => {
  const { data } = useQueryData(GET_ORDERS, {
    variables: {},
    fetchPolicy: "cache-and-network"
  })

  const { data: companyData } = useQuery(GET_COMPANIES, {
    fetchPolicy: "cache-and-network"
  })

  const [selectedCompany, setSelectedCompany] = useState()
  const [selectedOrder, setSelectedOrder] = useState()

  const getOrderNumbers = useMemo(() => {
    if (selectedCompany && selectedCompany.length > 0) {
      const orderNumbers = []
      selectedCompany.forEach(company => {
        data?.orders?.data?.forEach(order => {
          if (order.company.name === company.label) {
            if (order.orderNumber) {
              orderNumbers.push({
                label: order.orderNumber,
                value: order.orderNumber
              })
            }
          }
        })
      })
      return orderNumbers
    }
    return []
  }, [data, selectedCompany])

  const fieldsDefinition = useMemo(() => {
    return [
      {
        Header: "id",
        accessor: "id",
        show: false
      },
      {
        id: "orderNumber",
        accessor: "orderNumber",
        Header: "巨研訂單編號",
        style: columStyle
      },
      {
        id: "clientOrderNumber",
        accessor: "clientOrderNumber",
        Header: "公司訂單號碼",
        style: columStyle
      },
      {
        id: "companyName",
        accessor: data => data.company.name,
        Header: "客戶名稱",
        style: columStyle
      },
      {
        id: "orderStatus",
        Header: "訂單狀態",
        style: columStyle,
        accessor: data => findTypeValueByKey(orderStatusTypes, data.status)
      },
      {
        id: "orderDetails",
        accessor: data => data?.orderDetails?.length,
        Header: "商品數量",
        style: columStyle
      },
      {
        id: "orderAmounts",
        accessor: "totalAmount",
        Header: "訂單總金額",
        style: columStyle
      }
    ]
  }, [])

  const filteredResult = useMemo(() => {
    return (
      data?.orders?.data?.filter(item => {
        let contain = false
        !selectedCompany
          ? (contain = true)
          : selectedCompany.length > 0 &&
            selectedCompany?.forEach(company => {
              if (company.label === item.company.name) {
                if (selectedOrder && selectedOrder.length > 0) {
                  selectedOrder.forEach(order => {
                    if (order.label === item.orderNumber) {
                      contain = true
                    }
                  })
                } else {
                  contain = true
                }
              }
            })
        return contain && item.status !== "DRAFT"
      }) || []
    )
  }, [data, selectedCompany, selectedOrder])

  const makeExportDataRow = (order, orderDetail) => {
    const row = {}
    row.orderNumber = order.orderNumber
    row.clientOrderNumber = order.clientOrderNumber
    row.status = findTypeValueByKey(orderStatusTypes, order.status)
    row.totalAmount = order.totalAmount
    row.companyName = order.company.name
    row.userName = order.user.name
    row.updatedAt = order.updatedAt
    row.productName = orderDetail.product.name
    row.productNumber = orderDetail.product.productNumber
    row.productPrice = orderDetail.unitPrice
    row.productQuantity = orderDetail.quantity
    row.productSum = orderDetail.sum
    return row
  }

  const makeExportData = () => {
    const result = []
    filteredResult.forEach(order => {
      order.orderDetails.forEach(orderDetail => {
        result.push(makeExportDataRow(order, orderDetail))
      })
    })
    return result
  }

  const exportHeader = [
    // { label: "公司名稱", key: "companyName" },
    { label: "巨研訂單編號", key: "orderNumber" },
    { label: "公司訂單號碼", key: "clientOrderNumber" },
    { label: "狀態", key: "status" },
    { label: "訂購日期", key: "submittedTime" },
    { label: "產品名稱", key: "productName" },
    { label: "產品編號", key: "productNumber" },
    { label: "產品單價", key: "productPrice" },
    { label: "產品數量", key: "productQuantity" },
    { label: "產品小計", key: "productSum" },
    { label: "訂購人", key: "userName" }
  ]

  return (
    <>
      <Row className="mb-3">
        <Col md={12}>
          <FormGroup>
            <Label for="orderNumber">客戶</Label>
            <Select
              placeholder="選擇客戶"
              isMulti={true}
              value={selectedCompany}
              options={getOptions(companyData?.companies?.data, ["name"]).filter(
                item => item.label !== "GETECH"
              )}
              onChange={option => {
                setSelectedCompany(option)
              }}
            />
          </FormGroup>
        </Col>
        <Col md={12}>
          <FormGroup>
            <Label for="orderNumber">訂單</Label>
            <Select
              placeholder="選擇訂單"
              isMulti={true}
              value={selectedOrder}
              options={getOrderNumbers}
              onChange={option => {
                setSelectedOrder(option)
              }}
            />
          </FormGroup>
        </Col>
        <Col md={12}>
          <FormGroup>
            <CSVLink
              headers={exportHeader}
              data={makeExportData()}
              filename={"客戶訂單資料.csv"}
            >
              <Button size="sm" round="true" icon="true" className="mr-2">
                <i className="fas fa-download" />
              </Button>
            </CSVLink>
          </FormGroup>
        </Col>
      </Row>
      <Card>
        <CardBody>
          <ReactTable
            defaultPageSize={10}
            getTdProps={() => ({
              style: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center"
              }
            })}
            data={filteredResult}
            columns={[...fieldsDefinition]}
            showPagination={true}
          />
        </CardBody>
      </Card>
    </>
  )
}
const columStyle = { whiteSpace: "unset", textAlign: "center" }

export default OrderExportContainer
